import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Dropdown, Menu } from "antd";
import { FileExcelOutlined, FilePdfOutlined, ScheduleOutlined } from "@ant-design/icons";
import axios from "axios";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from "moment";
import { ButtonItem, MensajeError } from "../../../../../Components/Items";
import { limpiarNombreArchivo } from "../../../../../Components/ExcelTablaReporte";
import planProduccionPdf from "../../../../../Pdf/planProduccionPdf";
import { descargarPlanProduccionExcel } from "./planProduccion.utils";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const BotonPlanProduccionPU = ({ desde, hasta, etiquetaRango, presupuestoPUId, flujoId, soloPlaneadas }) => {
  const [cargando, setCargando] = useState(false);
  const empresaId = useSelector((state) => state.empresa.id);
  const empresaNombre = useSelector((state) => state.empresa.nombre);
  const headersToken = useSelector((state) => state.user.headersToken);
  const usuarioNombre = useSelector((state) => [state.user.nombre, state.user.apellidoPaterno, state.user.apellidoMaterno].filter(Boolean).join(" "));

  const consultar = (conEmpresa, alTerminar) => {
    setCargando(true);
    axios
      .post("ordenesDeProduccionPU/planeacionOrdenes", { empresaId, desde, hasta, presupuestoPUId, flujoId, conEmpresa, soloPlaneadas }, { headers: headersToken })
      .then((res) => {
        setCargando(false);
        if (res.data.success !== 2) {
          MensajeError({ message: res.data.error || "No se pudo generar el plan de producción" });
          return;
        }
        const todos = res.data.grupos || [];
        const conOrdenes = todos.filter((g) => g.ordenes.length > 0);
        alTerminar(conOrdenes.length ? conOrdenes : todos, res.data);
      })
      .catch(() => {
        setCargando(false);
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  const nombreArchivo = () => `${moment().format("DD MM YYYY")} Plan_produccion_${limpiarNombreArchivo(etiquetaRango)}`;

  const descargarExcel = () => consultar(false, (grupos) => descargarPlanProduccionExcel({ grupos, desde, hasta, empresaNombre, etiquetaRango, nombreArchivo: nombreArchivo() }));

  const descargarPdf = () =>
    consultar(true, (grupos, datos) =>
      pdfMake.createPdf(planProduccionPdf({ grupos, desde, hasta, empresa: datos.empresa || { nombre: empresaNombre }, etiquetaRango, usuarioNombre })).download(`${nombreArchivo()}.pdf`)
    );

  const menu = (
    <Menu>
      <Menu.Item key="excel" icon={<FileExcelOutlined style={{ color: "#217346" }} />} onClick={descargarExcel}>
        Excel
      </Menu.Item>
      <Menu.Item key="pdf" icon={<FilePdfOutlined style={{ color: "#df0101" }} />} onClick={descargarPdf}>
        PDF
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]}>
      <ButtonItem cyan botonAncho loading={cargando} icon={<ScheduleOutlined />}>
        Plan de producción
      </ButtonItem>
    </Dropdown>
  );
};

export default BotonPlanProduccionPU;
